export const download = (url, fileName) => {
  const tempLink = document.createElement('a');
  tempLink.href = url;
  tempLink.setAttribute('target', '_blank');
  tempLink.setAttribute('download', fileName || '');
  document.body.appendChild(tempLink);
  tempLink.click();
  document.body.removeChild(tempLink);
};
